import styled from 'styled-components';

import space from '../../assets/space.svg';
import footerBackground from '../../assets/footer.svg';

export const Card = styled.div`
  width: 100%;

  ${props => props.theme.breakpoints.up('md')} {
    display: flex;
  }

  ${props => props.theme.breakpoints.down('md')} {
    flex: 1;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    max-width: 650px;
    margin: 16px;

    background-color: ${props => props.theme.palette.background};
    color: ${props => props.theme.palette.text};

    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
    border-radius: ${props => props.theme.shape.medium}px;
    border: 3px solid ${props => props.theme.palette.secondary};
    overflow: hidden;
  }

  @media screen and (min-width: 1024px) {
    max-width: 750px;
  }

  ${props => props.theme.breakpoints.up('xl')} {
    max-width: 900px;
  }
`;

export const CardMedia = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  overflow: hidden;
  padding: 16px;

  background-image: url(${space});
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;

  min-height: 300px;

  ${props => props.theme.breakpoints.up('md')} {
    order: 1;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 50%;
    min-height: 350px;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    align-items: flex-end;
    padding: 16px 32px;
    min-height: 400px;
  }

  @media screen and (min-width: 1024px) {
    flex-basis: 50%;
    min-height: 500px;
  }
`;

export const CardContent = styled.div`
  flex-direction: column;
  padding: ${props =>
    `${props.theme.spacing(4)}px ${props.theme.spacing(2)}px`};
  text-align: center;

  ${props => props.theme.breakpoints.up('md')} {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 50%;
    text-align: justify;
    padding: ${props => `${props.theme.spacing(4)}px`};
  }

  ${props => props.theme.breakpoints.up('lg')} {
    justify-content: space-between;
  }

  @media screen and (min-width: 1024px) {
    flex-basis: 50%;
  }
`;

export const Heading = styled.h1`
  text-transform: uppercase;
  font-size: 36px;
  font-weight: 900;

  ${props => props.theme.breakpoints.up('xl')} {
    font-size: 48px;
  }
`;

export const SocialLogo = styled.img`
  ${props =>
    props.iconOnly
      ? `width: ${props.size || 48}px;`
      : `width: ${props.size || 150}px;`}
  ${props => (props.dark ? 'filter: invert(0.8);' : '')}
`;

export const CreatedBy = styled.small`
  // STYLES
`;

export const Footer = styled.footer`
  padding: ${props => `${props.theme.spacing(2)}px`};
  text-align: center;
  background-color: ${props => props.theme.palette.background};
  color: ${props => props.theme.palette.white};
  background-image: url(${footerBackground});
  background-size: 150%;
  background-position: 0 -40px;
  background-repeat: no-repeat;
  padding-top: ${() => (window.innerWidth / 10) * 1.3}px;

  @media screen and (min-width: 525px) {
    background-size: cover;
  }

  ${props => props.theme.breakpoints.up('xl')} {
    background-size: cover;
    background-position: 0 -40px;
    padding-top: ${props => `${props.theme.spacing(5)}px`};
  }
`;
